import useLocalStorage from 'nike-ui/src/common/hooks/useLocalStorage';

export default function useSessionStorage(key, initialValue) {
    return useLocalStorage(key, initialValue, window.sessionStorage);
}
